// extracted by mini-css-extract-plugin
export default {"bottomSlideInContent":"addEditForm_bottomSlideInContent__5WeHj"};